<template>
  <section>
    <vue-highcharts type="chart" :options="options" class="custom-heartrate" />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import VueHighcharts from 'vue3-highcharts'
import Highcharts from 'highcharts'

export default {
  name: 'session-heartrate-chart',
  components: {
    VueHighcharts,
  },
  props: {
    hrData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      value: 0,
    }
  },
  computed: {
    ...mapGetters('usercardio', ['memberGoals']),
    inzone() {
      let _data = {
        low: 0,
        high: 0,
      }
      if (this.memberGoals) {
        if (this.memberGoals.length > 0) {
          _data = {
            low: this.memberGoals[0].LowerLimitBPM
              ? parseInt(this.memberGoals[0].LowerLimitBPM)
              : 0,
            high: this.memberGoals[0].UpperLimitBPM
              ? parseInt(this.memberGoals[0].UpperLimitBPM)
              : 0,
          }
        }
      }
      console.log('InZone Data', _data)
      return _data
    },
    plotdata() {
      let _data = []
      if (this.hrData) {
        _data = this.hrData
      }
      return _data
    },
    options() {
      let _options = {
        chart: {
          type: 'spline',
          animation: false,
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        xAxis: {
          type: 'number',
          labels: {
            enabled: false,
            formatter: function () {
              return parseInt(this.value / 60)
            },
          },
          title: {
            text: '',
          },
        },
        yAxis: {
          title: {
            text: 'beats per minute',
          },
          minorGridLineWidth: 0,
          gridLineWidth: 0,
          alternateGridColor: null,
          min: 50,
          max: 200,
        },
        tooltip: {
          valueSuffix: ' b/s',
          formatter: function () {
            var minutes = parseInt(this.x / 60)
            return `<b>${this.y} bpm</b>`
          },
        },
        plotOptions: {
          area: {
            lineColor: Highcharts.getOptions().colors[8],
            fillColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1,
              },
              stops: [
                [0, Highcharts.getOptions().colors[8]],
                [
                  1,
                  Highcharts.color(Highcharts.getOptions().colors[8])
                    .setOpacity(0)
                    .get('rgba'),
                ],
              ],
            },
            marker: {
              radius: 2,
            },
            lineWidth: 1,
            states: {
              hover: {
                lineWidth: 1,
              },
            },
            threshold: null,
          },
          // area: {
          //   lineWidth: 3,
          //   states: {
          //     hover: {
          //       lineWidth: 4,
          //     },
          //   },
          //   marker: {
          //     enabled: false,
          //   },
          //   fillColor: {
          //     linearGradient: [0, 0, 0, 70],
          //     stops: [
          //       [0, 'rgb(0,0,0,0)'],
          //       [1, 'rgba(255,255,255,0)'],
          //     ],
          //   },
          // },
        },
        series: [
          {
            type: 'area',
            name: '',
            data: this.plotdata,
            animation: false,
          },
        ],
        navigation: {
          menuItemStyle: {
            fontSize: '10px',
          },
        },
      }
      return _options
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-heartrate {
  width: auto;
  height: 325px;
  margin: 0;
}
</style>
